<template>
  <div id="app">
    <loading></loading>
    <login></login>
    <we-dialog></we-dialog>
    <div class="weui-tab page">
      <div class="weui-tab__panel">
        <router-view class="view"></router-view>
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
  @import '~weui/dist/style/weui.min.css';
  @import './style/base.css'
  .bar-icon
    width 25px
    height 25px
  .bottom
    bottom: 0
  .page
    position absolute
    bottom 51px
    left 0
    right 0
    top 0
    background-color #fafafa
</style>

<script>
  import Login from './components/Login.vue'
  import api from './service/api'
  import errorHandler from './error/errorHandler'
  import Loading from './components/Loading'
  import WeDialog from './components/WeDialog'
  import router from './conf/router'

  export default{
    name: 'App',
    data () {
      return {
        icons: [
          [
            './assets/home_inactive.png',
            './assets/home_active.png'
          ],
          [
            './assets/form_inactive.png',
            './assets/form_active.png'
          ],
          [
            './assets/user_inactive.png',
            './assets/user_active.png'
          ]
        ],
        tab: [
          require('./assets/home_active.png'),
          require('./assets/form_inactive.png'),
          require('./assets/user_inactive.png')
        ],
        selected: 0
      }
    },

    methods: {
      tabOnClick (index) {
        this.tab[this.selected] = require(this.icons[this.selected][0])
        this.tab[index] = require(this.icons[index][1])
        this.selected = index
      }
    },

    computed: {
      route () {
        return this.$route
      }
    },

    mounted () {
      let th = this
      // third party login
      if (this.route.query && this.route.query.code) {
        console.log(this.route.query.code)
        // wechat login
        if (this.route.query.state === '1') {
          // login with code
          api.post('auth/thirdPartyLogin',
            {
              source: 'wechat',
              appid: 'wx47ecc77b53225372',
              appType: 'h5',
              code: this.route.query.code
            }
          )
          .then(
            (response) => {
              console.log(response)
              th.$store.dispatch('setUserInfo', response.data)
              window.window.sessionStorage.user = JSON.stringify(response.data) // 解决刷新后登录状态问题
            }
          )
          .catch(
            (error) => {
              errorHandler(error)
            }
          )
        } else {
          // login with code
          api.post('auth/thirdPartyLogin',
            {
              source: 'weibo',
              appid: '937571124',
              appType: 'h5',
              code: this.route.query.code
            }
          )
          .then(
            (response) => {
              console.log(response)
              th.$store.dispatch('setUserInfo', response.data)
              window.window.sessionStorage.user = JSON.stringify(response.data) // 解决刷新后登录状态问题
            }
          )
          .catch(
            (error) => {
              errorHandler(error)
            }
          )
        }
      }

      // home route
      router.push(this.route.fullPath)
    },

    components: {
      Login,
      Loading,
      WeDialog
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?13358176